import React from 'react';
import { Box, Typography, Paper } from '@mui/material';
import { useNavigate } from 'react-router-dom';

const SettingPoliciesCard = ({ icon, title, description, trending, link }) => {
    const navigate = useNavigate();

    return (
        <Paper
            elevation={0}
            onClick={() => !trending && link && navigate(link)} // Navigate only if not trending
            sx={{
                p: 2,
                height: '100%',
                width: '100%',
                position: 'relative',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between',
                gap: 1,
                cursor: 'pointer',
                borderRadius: trending ? '12px' : '0',
                backgroundColor: '#fff',
                boxShadow: trending ? '0 4px 20px rgba(0,0,0,0.06)' : 'none',
                '&:hover': {
                    boxShadow: trending
                        ? '0 6px 24px rgba(0,0,0,0.08)'
                        : '0 1px 4px rgba(0,0,0,0.06)',
                },
            }}
        >
            <Box>
                <Box sx={{mb:1}}>{icon}</Box>
                <Typography fontWeight={600} fontSize="15px">
                    {title}
                </Typography>
                <Typography fontSize="13px" color="text.secondary">
                    {description}
                </Typography>
            </Box>

            {/* Removed the toggle button for trending cards */}
        </Paper>
    );
};

export default SettingPoliciesCard;
